import React, { useEffect, useState } from 'react';
import './HomePage.scss';
import ArrowRight from '../../assets/icons/ic-arrow-right.svg';
import { HomePageDataModel, HomePageStateInterface } from './types';
// import { HOME_PAGE_INITIAL_STATE } from './config';
import AboutImage from '../../assets/images/about-img.png';
import { useTranslation } from "react-i18next";

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const HOME_PAGE_INITIAL_STATE: HomePageDataModel = {
    aboutData: {
      image: { source: AboutImage, alt: 'alltech office img' },
      text: {
        title: t('About_Alltech'),
        texts: [
          {
            __html: t('founded_in')},
          {
            __html: t('our_more')},
        ],
      },
    },
    blogData: {
      title: t('new_blog'),
      posts: [
        {
          image: {
            source:
              'https://www.alltech.com/sites/default/files/styles/16_9_large/public/2021-02/Untitled%20design%20%284%29%20%281%29.png?itok=xLbKqdNI',
            alt: 'blog image',
          },
          title: 'Twig Marston – Seizing Opportunities in the Beef Industry',
          text:
            'What some may view as obstacles, Twig Marston sees as opportunities. The beef nutritionist from Hubbard Feeds joins to share his thoughts on the current state of the beef industry and why he is optimistic about the industry becoming more efficient and sustainable.',
          link:
            'https://www.alltech.com/podcast-blog/twig-marston-seizing-opportunities-beef-industry',
        },
        {
          image: {
            source:
              'https://www.alltech.com/sites/default/files/styles/16_9_large/public/2021-02/Whats%20in%20the%20feed%20bag_web.png?itok=G1Si8QO8',
            alt: 'blog image',
          },
          title: 'How to read a horse feed tag',
          text:
            'As an involved horse owner, no doubt you have spent time carefully selecting a feed to match your horse’s needs. We are sure that you have read the purpose statement on the feed tag identifying the grain that will best suit your horse’s stage of life. You have likely even studied the guaranteed analysis to determine the feed’s crude protein, crude fat and crude fiber levels.',
          link: 'https://www.alltech.com/blog/how-read-horse-feed-tag',
        },
        {
          image: {
            source:
              'https://www.alltech.com/sites/default/files/styles/16_9_large/public/2021-02/2020%20harvest%20blog_web.png?itok=QFzegCe1',
            alt: 'blog image',
          },
          title: 'Diverse Weather Setting the Stage for Mycotoxin Risk',
          text:
            'If we learned anything from 2020, it is that we cannot control everything. For instance, we can’t control the weather, but we can work to control the mycotoxin risk it presents. Weather is the main influencing factor when it comes to mycotoxin risk, leading to a variation in risk levels across the U.S. This year is no exception to that trend, with mycotoxin levels having a wide distribution in the U.S. corn harvest. Mycotoxins can be responsible for the loss of production and efficiency in our animals — a duo we are not interested in.',
          link:
            'https://www.alltech.com/blog/diverse-weather-setting-stage-mycotoxin-risk',
        },
      ],
      linkToNews: 'https://www.alltech.com/blog',
    },
    alltechOneData: {
      video: { source: 'https://www.youtube.com/embed/O6zabmsY4jE' },
      text: {
        title: 'Alltech ONE Virtual Experience Highlights',
        texts: [
          t('the_alltech')
        ],
      },
      linkToSite: 'https://one.alltech.com/',
    },
    monthlySessionsData: {
      title: t('upcoming'),
      sessions: [
        {
          image: {
            source:
              'https://one.alltech.com/wp-content/uploads/2020/10/header_africa.png',
            alt: 'session image',
          },
          title: 'Africa: The Power of Partnership',
          date: 'November 19, 8 a.m. EST',
          link: 'https://one.alltech.com/africa-the-power-of-partnerships/',
        },
        {
          image: {
            source:
              'https://one.alltech.com/wp-content/uploads/2020/10/header_agribusiness.png',
            alt: 'session image',
          },
          title: 'Agri-Business',
          date: '',
          link: 'https://one.alltech.com/agri-business/',
        },
        {
          image: {
            source:
              'https://one.alltech.com/wp-content/uploads/2020/10/header_agtech.png',
            alt: 'session image',
          },
          title: 'Ag-Tech',
          date: '',
          link: 'https://one.alltech.com/ag-tech/',
        },
      ],
    },
  };
  const {
    aboutData,
    blogData,
    alltechOneData,
    monthlySessionsData,
  } = HOME_PAGE_INITIAL_STATE;

  return (
    <div className="page-content">
      <section className="about-section">
        <div className="container container-custom">
          <div className="row">
            <div className="col-6 col-xl-5">
              <div className="img-wrapper">
                <img
                  src={aboutData.image.source}
                  alt={aboutData.image.alt}
                  className="about-img"
                />
              </div>
            </div>
            <div className="col-6 col-xl-7">
              <div className="main-info">
                <h2 className="main-heading">{aboutData.text.title}</h2>
                <div className="main-text">
                  {aboutData.text.texts.map(t => (
                    <p
                      className="main-paragraph"
                      key={t.__html}
                      dangerouslySetInnerHTML={t}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="blog-section">
        <h2 className="main-heading">{blogData.title}</h2>
        <div className="container container-custom">
          <div className="blog-posts">
            <div className="row-custom">
              {blogData.posts.map(post => (
                <div className="col-custom" key={post.link}>
                  <div className="single-post">
                    <img
                      className="post-img"
                      src={post.image.source}
                      alt={post.image.alt}
                    />
                    <h3 className="post-heading">{post.title}</h3>
                    <p className="post-description">{post.text}</p>
                    <a href={post.link} className="post-link" target="_blank">
                      Read More <img src={ArrowRight} alt="arrow right" />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="discover-wrapper">
            <a
              href={blogData.linkToNews}
              target="_blank"
              className="discover-btn btn action-primary"
            >
              {t('discover_news')}
            </a>
          </div>
        </div>
      </section>
      <section className="highlights-section">
        <div className="container container-custom">
          <div className="row">
            <div className="col-6">
              <div className="highlights-video">
                <iframe
                  width="536"
                  height="340"
                  src={alltechOneData.video.source}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
            <div className="col-6">
              <div className="main-info">
                <div className="main-text">
                  {alltechOneData.text.texts.map(t => (
                    <p className="main-paragraph" key={t}>
                      {t}
                    </p>
                  ))}
                </div>
              </div>
              <a
                href={alltechOneData.linkToSite}
                target="_blank"
                className="highlights-link btn action-primary"
              >
                {t('learn_more')}
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="sessions-section">
        <h2 className="main-heading">{monthlySessionsData.title}</h2>
        <div className="container container-custom">
          <div className="sessions-posts">
            <div className="row-custom">
              {monthlySessionsData.sessions.map(session => (
                <div className="col-custom" key={session.title}>
                  <a href={session.link} target="_blank">
                    <div className="single-session">
                      <img
                        className="session-img"
                        src={session.image.source}
                        alt={session.image.alt}
                      />
                      <h3 className="session-heading">{session.title}</h3>
                      <p className="session-date">{session.date}</p>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export { HomePage };
